import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row clearfix pt-0 row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { id: "trip-detail-table" }
const _hoisted_4 = ["rowspan"]
const _hoisted_5 = ["rowspan"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["rowspan"]
const _hoisted_8 = ["rowspan"]

import { reactive, ref, Ref, watch, computed } from "vue";
import {
  formatDateTime,
} from "@/services/functions";
import AlertModal from "@/components/Common/AlertModal.vue";
import HeaderRow from "@/components/MonthlyReportWorkingTimesSettingParts/TableParts/HeaderRow.vue";
import TripRow from "@/components/MonthlyReportWorkingTimesSettingParts/TableParts/TripRow.vue";
import EmptyRow from "@/components/MonthlyReportWorkingTimesSettingParts/TableParts/EmptyRow.vue";
import WeeklyAggregationRow from "@/components/MonthlyReportWorkingTimesSettingParts/TableParts/WeeklyAggregationRow.vue";
import i18n from '@/lang/i18n';

type Props = {
  detailData?: any;
  alertSetting?: any;
  monthlyTrips?: any;
  maxWorkingTime?: any;
  displayWeeklyAggregation?: boolean;
  btnState?: boolean;
  trips: any
};

type Emits = {
  (e: "changeWorkingTime", value: any): void;
  (e: "clickSave", value: any): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'DetailTable',
  props: {
    detailData: {},
    alertSetting: {},
    monthlyTrips: {},
    maxWorkingTime: {},
    displayWeeklyAggregation: { type: Boolean },
    btnState: { type: Boolean },
    trips: {}
  },
  emits: ["changeWorkingTime", "clickSave"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const detailDataRef = reactive<Array<any>>(props.detailData);
const alertModalTitle = ref("");
const alertModalMessage = ref("");
const modalState = ref(false);

const validationResults:Ref<{[key:number]: boolean}> = ref({})

const setValidationResult = (key: string, value: boolean) => {
  validationResults.value[key] = value;
}

const emit = __emit;

watch(
  () => props.btnState,
  () => {
    if (!props.btnState) return;

    const invalid = Object.values(validationResults.value).includes(false);
    if (invalid) {
      emit("clickSave", {valid: !invalid, workingTimes: []});
      return ;
    }

    const workingTimes = [];
    detailDataRef.forEach((detailData) => {
      (detailData?.trips ?? []).forEach((trip) => {
        workingTimes.push({
          delivery_plan_id: trip.delivery_plan_id,
          sub_id: trip.sub_id,
          start_at: formatDateTime(new Date(trip.csv_start_working_time)),
          end_at: formatDateTime(new Date(trip.csv_end_working_time)),
          is_ittenko_cooperation: {
            start: trip?.is_ittenko_cooperation?.start,
            end: trip?.is_ittenko_cooperation?.end,
          },
        });
      });
    });

    return emit("clickSave", { valid: !invalid, workingTimes: workingTimes });
  }
);

const getRowSpan = (trips: any) => {
  return trips.length > 1 ? 1 : 2;
};

const convertDayOfWeekToJa = (dayOfWeekEn: string) => {
  return {
    Sun: i18n.global.t('pages.common.weeks.Sun'),
    Mon: i18n.global.t('pages.common.weeks.Mon'),
    Tue: i18n.global.t('pages.common.weeks.Tue'),
    Wed: i18n.global.t('pages.common.weeks.Wed'),
    Thu: i18n.global.t('pages.common.weeks.Thu'),
    Fri: i18n.global.t('pages.common.weeks.Fri'),
    Sat: i18n.global.t('pages.common.weeks.Sat'),
  }[dayOfWeekEn];
};

function showAlert(message: string) {
  alertModalTitle.value = i18n.global.t('pages.monthlyReportWorkingTimesSetting.inputError');
  alertModalMessage.value = message;
  modalState.value = true;
}

const closeAlert = () => {
  alertModalTitle.value = "";
  alertModalMessage.value = "";
  modalState.value = false;
};

const getDayRowSpan = (trips) => {
  const length = trips.length;
  return length == 0 ? 1 : length;
};

const getTrip = (dayIndex, tripIndex, direction) => {
  let trips = detailDataRef[dayIndex]?.trips ?? [];
  let target = trips[tripIndex + direction];
  if (target) return target;

  const len = detailDataRef.length;
  for (let i = dayIndex + direction; i >= 0 && i < len; i += direction) {
    if (!detailDataRef[i]?.trips.length) continue;
    trips = detailDataRef[i]?.trips;
    const index = direction < 0 ? trips.length - 1 : 0;
    target = trips[index];
    break;
  }
  return target;
};

const cloneTrip = (trip) => {
  return JSON.parse(JSON.stringify(trip ?? "{}"));
};

const makeLeavingDiffTime = computed(() => (detailIndex: number, tripIndex: number) => {
  const isLastDay = detailDataRef[detailIndex + 1] == undefined
  if (!isLastDay && (tripIndex != 0 || !detailDataRef[detailIndex + 1]?.trips.length)) return 0

  const appointedDay = new Date(detailDataRef[detailIndex].trips[tripIndex].csv_start_working_time)
  const AddedDay = appointedDay.setDate(appointedDay.getDate() + 1)

  let nextDayLeavingTime
  if (isLastDay) {
    nextDayLeavingTime = props.trips[props.trips.length - 1].csv_start_working_time
  } else {
    nextDayLeavingTime = detailDataRef[detailIndex + 1].trips[0].csv_start_working_time
  }

  const diffSeconds = (AddedDay - new Date(nextDayLeavingTime)) / 1000
  return diffSeconds < 0 ? 0 : diffSeconds
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createVNode(HeaderRow),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailDataRef, (detailData, detail_i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: detail_i }, [
            (detailData.trips.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(detailData.trips, (trip, trip_i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: trip_i }, [
                    (trip_i == 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("td", {
                            rowspan: getDayRowSpan(detailData.trips)
                          }, _toDisplayString(detailData.day), 9, _hoisted_4),
                          _createElementVNode("td", {
                            rowspan: getDayRowSpan(detailData.trips)
                          }, _toDisplayString(convertDayOfWeekToJa(detailData.dayOfWeek)), 9, _hoisted_5)
                        ], 64))
                      : _createCommentVNode("", true),
                    (detailData.trips.length)
                      ? (_openBlock(), _createBlock(TripRow, {
                          key: 1,
                          rowSpan: getRowSpan(detailData.trips),
                          beforeTrip: getTrip(detail_i, trip_i, -1),
                          trip: cloneTrip(props.detailData[detail_i].trips[trip_i]),
                          afterTrip: getTrip(detail_i, trip_i, 1),
                          modelValue: detailDataRef[detail_i].trips[trip_i],
                          "onUpdate:modelValue": ($event: any) => ((detailDataRef[detail_i].trips[trip_i]) = $event),
                          maxWorkingTime: __props.maxWorkingTime,
                          alertSetting: __props.alertSetting,
                          showAlert: showAlert,
                          setValidationResult: setValidationResult,
                          leavingDiffTime: makeLeavingDiffTime.value(detail_i, trip_i)
                        }, null, 8, ["rowSpan", "beforeTrip", "trip", "afterTrip", "modelValue", "onUpdate:modelValue", "maxWorkingTime", "alertSetting", "leavingDiffTime"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("td", {
                    rowspan: getDayRowSpan(detailData.trips)
                  }, _toDisplayString(detailData.day), 9, _hoisted_7),
                  _createElementVNode("td", {
                    rowspan: getDayRowSpan(detailData.trips)
                  }, _toDisplayString(convertDayOfWeekToJa(detailData.dayOfWeek)), 9, _hoisted_8),
                  _createVNode(EmptyRow, {
                    detailData: detailData,
                    rowSpan: 2
                  }, null, 8, ["detailData"])
                ])),
            _withDirectives(_createElementVNode("tr", null, null, 512), [
              [_vShow, !detailData.trips.length]
            ]),
            _withDirectives(_createElementVNode("tr", null, null, 512), [
              [_vShow, detailData.trips.length == 1]
            ]),
            _createVNode(WeeklyAggregationRow, {
              detailDataRef: detailDataRef,
              index: detail_i,
              detailData: detailData,
              alertSetting: __props.alertSetting
            }, null, 8, ["detailDataRef", "index", "detailData", "alertSetting"])
          ], 64))
        }), 128))
      ])
    ]),
    _createVNode(AlertModal, {
      modalState: modalState.value,
      title: alertModalTitle.value,
      subTitle: alertModalMessage.value,
      modalMaxWidth: "60%",
      onCloseModal: closeAlert
    }, null, 8, ["modalState", "title", "subTitle"])
  ]))
}
}

})